import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import filter from 'lodash/filter'

import PageListTemplate from '../components/templates/PageListTemplate'

const PageList = ({data, pageContext}) => {
  const pages = get(data, 'allMarkdownRemark.edges')
  const examples = filter(pages, page => !page.node.frontmatter.client)
  const clients = filter(pages, page => page.node.frontmatter.client)
  const tag = get(pageContext, 'tag')

  return (
    <PageListTemplate
      examples={examples}
      clients={clients}
      tag={tag}
    />
  )
}

export default PageList

export const pageListQuery = graphql`
  query PageListQuery($tag: String) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___title], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            client
            tags
          }
        }
      }
    }
  }
`